module.exports = __webpack_public_path__ + "img/michael.8e910379.png";